import { useState } from 'react'
import classes from './DetailsVerticalListTrigger.module.css'
import DetailsVerticalList from './DetailsVerticalList'
import { detailsActions } from '../../../store/details'
import { useDispatch, useSelector } from 'react-redux'
import OutsideClickComponent from '../../fragments/OutsideClickComponent'
// import { useSelector } from 'react-redux';

export default function DetailsVerticalListTrigger() {
    // const [showSidebar, setShowSidebar] = useState(false)
    const dispatch = useDispatch()
    // const patientData = useSelector(state => state.filter.currentpagedata)

    const isVerticalListOpened = useSelector(state => state.details.isVerticalListOpened)

    let typingTimer;                
    const doneTypingInterval = 300;  

    function mouseEnterHandler() {     
        clearTimeout(typingTimer);  
        typingTimer = setTimeout(secondsPassed, doneTypingInterval);
    }

    function mouseLeaveHandler() {
        // setShowSidebar(false)
        dispatch(detailsActions.setIsVerticalListOpened(false))
        clearTimeout(typingTimer);
    }

    const secondsPassed = () => {
        // setShowSidebar(true) 
        dispatch(detailsActions.setIsVerticalListOpened(true))
        dispatch(detailsActions.setDrawerHasOpened(true))
    }

    
    return <div className={classes.container} onMouseEnter={mouseEnterHandler} onMouseLeave={mouseLeaveHandler}>
        <button className={classes.button}>
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M6.75 4.5H15M6.75 9H15M6.75 13.5H15M3.75 4.5V4.5075M3.75 9V9.0075M3.75 13.5V13.5075" stroke="#0A2E72" strokeWidth="0.75" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        </button>

        <OutsideClickComponent task={mouseLeaveHandler}>
            <div className={`${classes.list_wrapper} ${isVerticalListOpened ? classes.list_opened : classes.list_closed}`}>
                {/* <DetailsVerticalList passApi={(patientData) ? true : false}/> */}
                <DetailsVerticalList />
            </div>
        </OutsideClickComponent>
        
    </div>
}